import React, { useState } from 'react';
import { SearchBar } from '../components/SearchBar';
import { accessories } from '../data/products';
import { ProductCard } from '../components/ProductCard';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Accessories: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const filteredAccessories = accessories.filter(accessory =>
    accessory.brand.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="pt-16 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white mb-6 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span>Back</span>
        </button>

        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4 md:mb-0">
            Gas Accessories
          </h1>
          <div className="w-full md:w-96">
            <SearchBar value={searchTerm} onChange={setSearchTerm} />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredAccessories.map(accessory => (
            <ProductCard key={accessory.id} product={accessory} isAccessory />
          ))}
        </div>

        {filteredAccessories.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 dark:text-gray-400">
              No accessories found matching your search criteria.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};